import { USER_API_URL } from '../constants';
import { CONFIG } from '../config';
import { ERROR_MESSAGES } from './authenticate';

export type OtpCodeResponse = {
  message: string;
};

export const sendOTPCode = async (userId: string, email: string, accessToken: string) => {
  const response = await fetch(`${USER_API_URL}/v2/email_otp`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/vnd.api+json',
      authorization: accessToken ? `Bearer ${accessToken}` : '',
      'X-Bypass-Rack-Attack': CONFIG.BYPASS_RACK_ATTACK
    },
    body: JSON.stringify({
      data: {
        id: userId,
        type: 'user',
        attributes: {
          email
        }
      }
    })
  });

  const data: OtpCodeResponse = await response.json();
  if (data.message == null) {
    throw new Error(ERROR_MESSAGES.default);
  }

  return data.message;
};
